module.exports = __webpack_public_path__ + "static/media/unlike-icon.51cf2f95.svg";